// material-ui
import {Typography} from '@mui/material';

// project imports
import NavGroup from './NavGroup';
// import menuItem from '../../menu-items';
import {useSelector} from "react-redux";
import {getState} from "../../../../redux/actions/actions";
import MenuItems from '../../menu-items';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const authState = useSelector((state: any) => state.auth.authData);
    const user = getState(authState);

    const navItems = MenuItems().items.map((item: any) => {
        switch (item.type) {
            case 'group':
                return item?.role?.includes(user?.role) &&
                    <NavGroup key={item.id} item={item} user={user}/>;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
